import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-[5%] py-2 lg:py-5 mx-auto flex justify-between" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-[69px] lg:h-[55px] lg:invert lg:brightness-0 lg:contrast-100 lg:saturate-100",
  src: "/assets/shinagawa-logo.svg",
  alt: "logo"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center space-x-6 text-white" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-3/12 flex items-center justify-end space-x-4" }, null, -1)

import { 
    IonHeader, 
} from '@ionic/vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import { MagnifyingGlassIcon, ChevronDownIcon } from "@heroicons/vue/24/solid";
import AuthService from "@/classes/AuthService";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavigation',
  setup(__props) {

const viewDashboard = () => {
    if(!AuthService.isAuthenticated()) {
        AuthService.logout()
    } else {
        window.location.replace('/overview')
    }
}

const socialaccts = [
    {
        icon: '/assets/icon/ic-facebook.svg',
        link: 'https://www.facebook.com/shinagawadiagnostic',
    },
    {
        icon: '/assets/icon/ic-instagram.svg',
        link: 'https://www.instagram.com/shinagawadiagnostic/',
    },
    {
        icon: '/assets/icon/ic-youtube.svg',
        link: 'https://www.youtube.com/@ShinagawaPhilippines',
    },
    {
        icon: '/assets/icon/ic-linkedin.svg',
        link: 'https://www.linkedin.com/in/shinagawa-philippines/',
    }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), { class: "w-full frm-header" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: _unref(AuthService).isAuthenticated() ? '/overview' : '/login'
          }, _hoisted_5, 8, _hoisted_3)
        ]),
        _hoisted_6,
        _hoisted_7
      ])
    ]),
    _: 1
  }))
}
}

})